import { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Fuel, Plus, X } from "lucide-react";
import { fmtKc, fmtNum2 } from "../../lib/format";

// Detail přijaté faktury (jen vlastník/admin): seznam přiřazených tankování + dodatečné přiřazení nepřiřazených.
export function InvoiceFuelings({ invoiceId }) {
    const [linked, setLinked] = useState([]);
    const [free, setFree] = useState([]);
    const [sel, setSel] = useState("");
    const load = () => {
        api.get(`/fleet/fuelings?received_invoice_id=${invoiceId}`).then((r) => setLinked(r.data.items)).catch(() => {});
        api.get("/fleet/fuelings?unlinked=true").then((r) => setFree(r.data.items)).catch(() => {});
    };
    useEffect(() => { load(); }, [invoiceId]); // eslint-disable-line
    const link = async (fid, target) => {
        try { await api.put(`/fleet/fuelings/${fid}/invoice`, { received_invoice_id: target }); setSel(""); load(); }
        catch (e) { toast.error(e.response?.data?.detail || "Uložení selhalo"); }
    };
    const liters = linked.reduce((a, f) => a + (Number(f.liters) || 0), 0);
    const amount = linked.reduce((a, f) => a + (Number(f.amount) || 0), 0);
    return (
        <div className="border border-slate-200 p-3" data-testid="invoice-fuelings">
            <div className="flex items-center justify-between mb-2">
                <div className="label-eyebrow inline-flex items-center gap-1"><Fuel className="w-3 h-3" /> Tankování k dokladu ({linked.length})</div>
                {linked.length > 0 && <div className="text-[11px] text-slate-500 tabular-data">{fmtNum2(liters)} l · {fmtKc(amount)}</div>}
            </div>
            {linked.map((f) => (
                <div key={f.id} className="flex items-center gap-2 text-xs py-1.5 border-t border-slate-100" data-testid={`invoice-fueling-${f.id}`}>
                    <span className="flex-1 min-w-0 truncate">{(f.datetime || "").replace("T", " ")} · {f.vehicle_name} · <b>{fmtNum2(f.liters)} l</b>{f.amount != null ? ` · ${fmtKc(f.amount)}` : ""}{f.created_by_name ? ` · ${f.created_by_name}` : ""}</span>
                    <button onClick={() => link(f.id, null)} className="min-w-[36px] min-h-[36px] inline-flex items-center justify-center text-slate-400 hover:text-red-600" title="Odpojit" data-testid={`invoice-fueling-unlink-${f.id}`}><X className="w-3.5 h-3.5" /></button>
                </div>
            ))}
            {free.length > 0 && (
                <div className="flex gap-2 mt-2">
                    <select value={sel} onChange={(e) => setSel(e.target.value)} className="flex-1 min-w-0 text-xs border border-slate-300 px-2 py-1.5 rounded-sm bg-white" data-testid="invoice-fueling-select">
                        <option value="">— přiřadit nepřiřazené tankování —</option>
                        {free.map((f) => <option key={f.id} value={f.id}>{(f.datetime || "").replace("T", " ")} · {f.vehicle_name} · {fmtNum2(f.liters)} l{f.amount != null ? ` · ${fmtKc(f.amount)}` : ""}</option>)}
                    </select>
                    <button onClick={() => sel && link(sel, invoiceId)} disabled={!sel} className="inline-flex items-center gap-1 px-3 text-xs border border-slate-900 hover:bg-slate-900 hover:text-white disabled:opacity-40 rounded-sm" data-testid="invoice-fueling-add"><Plus className="w-3 h-3" /> Přiřadit</button>
                </div>
            )}
        </div>
    );
}
